class UserModel {
    _data = {
        codigo: String,
        tipo: String,
        CNPJ_CNPF: String,
        nome: String,
        endereco: String,
        numero: String,
        complemento: String,
        bairro: String,
        cidade: String,
        distrito: String,
        uf: String,
        cep: String,
        telComercial: String,
        telResidencial: String,
        telCelular: String,
        bcoCobr: String,
        RG_IE: String,
        nascimento: String,
        codCobr: String,
        cobranca: String,
        tipoImpressao: String,
        diaCobr: String,
        diasProtesto: String,
        sigla: String,
        cobrEndereco: String,
        cobrComplemento: String,
        cobrBairro: String,
        cobrCidade: String,
        cobrUF: String,
        cobrCEP: String,
        bloqueavel: String,
        inclusao: String,
        usuario: String,
        observacoes: String,
        mapsMarkLat: String,
        mapsMarkLng: String,
        grupo: String,
        situacao: String,
        email: String
    }

    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        this._data.codigo = data.Codigo || '',
        this._data.tipo = data.Tipo || '',
        this._data.CNPJ_CNPF = data.CNPJ_CNPF || '',
        this._data.nome = data.Nome || '',
        this._data.endereco = data.Endereco || '',
        this._data.numero = data.Numero || '',
        this._data.complemento = data.Complemento || '',
        this._data.bairro = data.Bairro || '',
        this._data.cidade = data.Cidade || '',
        this._data.distrito = data.Distrito || '',
        this._data.uf = data.UF || '',
        this._data.cep = data.CEP || '',
        this._data.telComercial = data.TelComercial || '',
        this._data.telResidencial = data.TelResidencial || '',
        this._data.telCelular = data.TelCelular || '',
        this._data.bcoCobr = data.BcoCobr || '',
        this._data.RG_IE = data.RG_IE || '',
        this._data.nascimento = data.Nascimento || '',
        this._data.codCobr = data.CodCobr || '',
        this._data.cobranca = data.Cobranca || '',
        this._data.tipoImpressao = data.TipoImpressao || '',
        this._data.diaCobr = data.DiaCobr || '',
        this._data.diasProtesto = data.DiasProtesto || '',
        this._data.sigla = data.Sigla || '',
        this._data.cobrEndereco = data.Cobr_Endereco || '',
        this._data.cobrComplemento = data.Cobr_Complemento || '',
        this._data.cobrBairro = data.Cobr_Bairro || '',
        this._data.cobrCidade = data.Cobr_Cidade || '',
        this._data.cobrUF = data.Cobr_UF || '',
        this._data.cobrCEP = data.Cobr_CEP || '',
        this._data.bloqueavel = data.Bloqueavel || '',
        this._data.inclusao = data.Inclusao || '',
        this._data.usuario = data.usuario || '',
        this._data.observacoes = data.Observacoes || '',
        this._data.mapsMarkLat = data.MapsMarkLat || '',
        this._data.mapsMarkLng = data.MapsMarkLng || '',
        this._data.grupo = data.Grupo || '',
        this._data.situacao = data.Situacao || '',
        this._data.email = data.Email || ''
    }

    getData () {
        return this._data;
    }
}

export default UserModel;